export default {
  title: 'Something went wrong. Please try again.',
  retry: 'Retry',
};
